import { type SavedCguType } from "@/features/cgu/types";
import type { ConfirmationResponse } from "@/features/register/types";
import { fetchServer } from "@/features/utils/fetch";

export class UserCguApiClient {
  static async saveRequestCGU(TermUuid: string): Promise<ConfirmationResponse> {
    const response = await fetchServer(`/user/consent`, {
      method: "POST",
      body: { TermUuid: TermUuid }
    });

    if (!response.ok) throw new Error();
    const json = await response.json();

    return json;
  }
  static async getUserRequestCGU(): Promise<SavedCguType[]> {
    const response = await fetchServer(`/user/consent`, {
      method: "GET"
    });

    if (!response.ok) throw new Error();
    const json = await response.json();
    return json.data;
  }
}
